var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinebackgroundMaskgroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1124,
    height: 820,
    viewBox: "0 0 1124 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.07,
    filter: "url(#filter0_d_1952_250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1952_250",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 1116,
    height: 812
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.813 0C338.886 0 313.813 25.072 313.813 56V86.2231H821.015V56C821.015 25.0721 795.943 0 765.015 0H369.813ZM54 116C26.3858 116 4 138.386 4 166V762C4 789.614 26.3857 812 54 812H1070C1097.61 812 1120 789.614 1120 762V166C1120 138.386 1097.61 116 1070 116H54Z",
    fill: "#0D226A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1952_250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-240.282 810.021L551.809 862L-237.31 775.686C-238.564 787.031 -239.546 798.485 -240.282 810.021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-232.7 740.288L551.919 861.127L-226.782 706.363C-228.964 717.571 -230.955 728.862 -232.7 740.288Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-219.065 671.456L552.109 860.281L-210.175 638.185C-213.365 649.175 -216.338 660.275 -219.065 671.456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-199.458 604.096L552.381 859.436L-187.649 571.753C-191.822 582.443 -195.749 593.242 -199.458 604.096Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-173.984 538.782L552.71 858.618L-159.394 507.529C-164.467 517.837 -169.348 528.228 -173.984 538.782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-142.871 475.867L553.117 857.827L-125.635 446.06C-131.58 455.85 -137.335 465.804 -142.871 475.867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-106.409 415.952L553.581 857.091L-86.6371 387.781C-93.4276 397.026 -100.027 406.407 -106.409 415.952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-64.873 359.446L554.128 856.382L-42.7289 333.075C-50.3102 341.693 -57.6735 350.501 -64.873 359.446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-18.5684 306.731L554.726 855.727L5.73024 282.433C-2.53292 290.369 -10.6324 298.468 -18.5684 306.731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0747 258.27L555.381 855.127L58.4459 236.126C49.501 243.326 40.6924 250.689 32.0747 258.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7803 214.364L556.09 854.582L114.951 194.592C105.406 200.974 96.0252 207.573 86.7803 214.364Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.059 175.366L556.826 854.118L174.866 158.131C164.803 163.667 154.849 169.421 145.059 175.366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.528 141.604L557.617 853.709L237.781 127.014C227.227 131.65 216.837 136.532 206.528 141.604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.751 113.351L558.435 853.382L303.095 101.543C292.241 105.252 281.441 109.179 270.751 113.351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.185 90.8255L559.281 853.109L370.455 81.9351C359.274 84.6622 348.175 87.6347 337.185 90.8255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.363 74.2173L560.127 852.918L439.288 68.2995C427.862 70.0448 416.571 72.0356 405.363 74.2173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.686 63.6907L560.999 852.809L509.021 60.7181C497.485 61.4544 486.031 62.4362 474.686 63.6907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.664 59.1909L561.899 852.755L579.108 59.1909C573.381 59.0545 567.654 59 561.899 59C556.145 59 550.418 59.0545 544.664 59.1909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.751 60.7181L562.745 852.809L649.085 63.6907C637.713 62.4362 626.259 61.4544 614.751 60.7181Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.484 68.2995L563.618 852.918L718.409 74.2173C707.174 72.0356 695.883 70.0448 684.484 68.2995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.317 81.9351L564.491 853.109L786.56 90.8255C775.57 87.6347 764.471 84.6622 753.317 81.9351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.648 101.543L565.335 853.382L852.992 113.351C842.329 109.179 831.529 105.252 820.648 101.543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M885.99 127.014L566.127 853.709L917.216 141.604C906.935 136.532 896.517 131.65 885.99 127.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M948.905 158.131L566.918 854.118L978.685 175.366C968.895 169.421 958.968 163.667 948.905 158.131Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1008.79 194.592L567.682 854.582L1036.99 214.364C1027.75 207.573 1018.34 200.974 1008.79 194.592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1065.33 236.126L568.364 855.127L1091.67 258.27C1083.05 250.689 1074.27 243.326 1065.33 236.126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1118.01 282.433L569.046 855.727L1142.34 306.731C1134.4 298.468 1126.3 290.369 1118.01 282.433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1166.47 333.075L569.618 856.382L1188.65 359.446C1181.42 350.501 1174.06 341.693 1166.47 333.075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.38 387.781L570.162 857.091L1230.18 415.952C1223.77 406.407 1217.17 397.026 1210.38 387.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1249.38 446.06L570.628 857.827L1266.64 475.867C1261.08 465.804 1255.33 455.85 1249.38 446.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1283.17 507.529L571.035 858.618L1297.76 538.782C1293.09 528.228 1288.21 517.837 1283.17 507.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1311.42 571.753L571.389 859.436L1323.2 604.096C1319.49 593.242 1315.56 582.443 1311.42 571.753Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1333.94 638.185L571.634 860.281L1342.84 671.456C1340.08 660.275 1337.11 649.175 1333.94 638.185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1350.53 706.363L571.826 861.127L1356.47 740.288C1354.73 728.862 1352.74 717.571 1350.53 706.363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1361.08 775.686L571.962 862L1364.03 810.021C1363.32 798.485 1362.31 787.031 1361.08 775.686Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1952_250",
    x: 0,
    y: 59,
    width: 1124,
    height: 761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1952_250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1952_250",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinebackgroundMaskgroup);
export default __webpack_public_path__ + "static/media/line backgroundMask group.555ceeca0950b093893e86a007d3bce9.svg";
export { ForwardRef as ReactComponent };